/* global process, btoa */
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query";

export interface AddonAccessToken {
  access_token: string;
}

export const AuthApi = createApi({
  reducerPath: "authApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.AUTH_BASE_URL,
  }),
  endpoints: (builder) => ({
    login: builder.mutation<AddonAccessToken, void>({
      query: () => {
        const basicAuthToken = btoa(`${process.env.AUTH_CLIENT_ID}:${process.env.AUTH_CLIENT_SECRET}`);
        const body = new URLSearchParams();
        body.append("grant_type", "client_credentials");
        return {
          url: "token",
          method: "POST",
          headers: {
            Authorization: `Basic ${basicAuthToken}`,
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body,
        };
      },
    }),
  }),
});
